import { useState } from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useComplaintsCategories } from 'modules/complaints/hooks/useComplaintsCategories'

import { AddCategoryModal } from './AddCategoryModal'
import CategoriesTable from './CategoriesTable'

export const CategoriesSettings = () => {
  const [addCategoryModalOpen, setAddCategoryModalOpen] = useState(false)
  const { categories, loading } = useComplaintsCategories()

  return (
    <Section
      illustration="handing-paper"
      title={i18n.t('app_store_v2.apps.complaints.settings.categories.title')}
      description={i18n.t('app_store_v2.apps.complaints.settings.categories.description')}
      action={{
        label: i18n.t('app_store_v2.apps.complaints.settings.categories.new_category'),
        onClick: () => setAddCategoryModalOpen(true),
      }}
    >
      <AddCategoryModal
        open={addCategoryModalOpen}
        onClose={() => setAddCategoryModalOpen(false)}
      />
      <CategoriesTable categories={categories} loading={loading} />
    </Section>
  )
}
